module.exports = __webpack_public_path__ + "static/media/52.050b086d.png";